import NextImage from 'next/image';
import { Mail, Phone } from 'lucide-react';
import { getStrapiFormatUrl } from '@/lib/strapi-media-url';
import { getCmsButtonLinkProps } from '@/lib/cms-button-target';
import type { ButtonItem } from '@/types/homepage';

interface ContactHeroButtonProps {
  button: ButtonItem;
}

export default function ContactHeroButton({ button }: ContactHeroButtonProps) {
  const href = button.buttonUrl?.trim();
  const label = button.buttonText?.trim() || button.ariaLabel?.trim() || '';
  const iconUrl = getStrapiFormatUrl(button.buttonIcon);

  if (!label || !href) return null;

  let icon: React.ReactNode;
  if (iconUrl) {
    icon = <NextImage src={iconUrl} alt="" width={10} height={10} className="h-2.5 w-2.5" />;
  } else if (href.startsWith('mailto:')) {
    icon = <Mail size={10} strokeWidth={2.5} />;
  } else {
    icon = <Phone size={10} strokeWidth={2.5} />;
  }

  return (
    <a
      href={href}
      {...getCmsButtonLinkProps(button)}
      aria-label={button.ariaLabel?.trim() || label}
      className="ct-chip inline-flex items-center gap-2.5 rounded-full border border-white/15 bg-white/8 px-4 py-2.5 text-[13px] font-semibold text-white backdrop-blur-sm transition-all duration-200 hover:bg-white hover:text-[#1C1917]"
    >
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#E31E24]">
        {icon}
      </span>
      {label}
    </a>
  );
}
